module.exports = __webpack_public_path__ + "static/customer_zikto_logo-464ad2ca4c05b66466a9a8abf1f9b168.svg";